import { useState, useRef, useMemo } from 'react';
import { TextBox} from 'devextreme-react/text-box';
import notify from 'devextreme/ui/notify';
import List from 'devextreme-react/list';
import './address-auto-complete.scss';
import debounce from 'debounce';
import { useAddressVerificationApiService } from '~/services';

export function AddressAutoComplete(props) {
  const [items, setItems] = useState([]);
  const { getAutoCompleteAddresses } = useAddressVerificationApiService();
  const { updateAddressFields, city, province, setAddressVerified } = props;

  const textBoxRef = useRef(null);

  const debouncedFetchData = useMemo(
    () => debounce(async () => {
      try {
        const searchValue = textBoxRef?.current?.instance()?.option('value');
        if (searchValue) {
          const data = await getAutoCompleteAddresses(searchValue, city, province);
          setItems(data);
        }
      } catch (error) {
        notify('Error in getting the addresses.', 'error', 2000);
      }
    }, 150),
    [getAutoCompleteAddresses, city, province]
  );

  async function handleChange(e) {
    if (typeof e.event !== 'undefined') {
      props.onValueChanged(e.value);
      if (props.addressVerified) setAddressVerified(false);
      if (e.value === '') {
        setItems([]);
      } else {
        debouncedFetchData();
      }
    }
  }

  async function handleSelectionAsync(place_id) {
    try {
      const address = items.find(x => x.place_id === place_id);
      if (address) {

        textBoxRef?.current?.instance()?.option('value', address.fullAddress.address);

        updateAddressFields({
          address: address.fullAddress.address,
          city: address.fullAddress.city,
          postalCode: address.fullAddress.pc,
          province: address.fullAddress.prov,
        });
      }
    } catch {
      notify('Error in getting the address.', 'error', 2000);
    }
  }

  function itemRender(item) {
    return (<div className="address-list-item">
      {item.description}
    </div>);
  }

  const { addressVerified } = props;
  return (
    <div className="address-autocomplete-container-wrapper">
      <div className="address-autocomplete-container">
        <TextBox
          ref={textBoxRef}
          showClearButton
          valueChangeEvent="keyup"
          defaultValue={props.value}
          onValueChanged={async (e) => await handleChange(e)}
          onKeyDown={(e) => {
            if (e.event.key === "Escape") setItems([]);
          }}
          placeholder="Unit#-Street Number Street Name City"
          inputAttr={{ style: "text-transform: uppercase" }}
          buttons={[
            {
              name: "addressVerification",
              location: "after",
              options: {
                visible: (addressVerified !== undefined) && addressVerified,
                hint: "Address Verified",
                icon: "check",
                type: "default",
              },
            },
          ]}
        />
        <div className="address-autocomplete-container-address-list">
          <List
            showScrollbar={"always"}
            height={Math.min(300, 35 * (items.length + 1))}
            keyExpr="place_id"
            dataSource={items}
            visible={items.length > 0}
            itemRender={itemRender}
            selectionMode="single"
            onSelectionChanged={
              async (e) => {
                setItems([]);
                if (e.addedItems.length === 0) return;
                await handleSelectionAsync(e.addedItems[0].place_id);
              }
            }
          />
        </div>
      </div>
    </div>
  );
}